import { computed } from 'vue';
import { useWindowSize } from '@vueuse/core';

export const useIsMobile = (breakpoint = 768) => {
  const { width } = useWindowSize();
  const isMobile = computed(() => width.value <= breakpoint);
  return { width, isMobile };
};
